import { useSelector } from 'react-redux';
import { useGetUserInfoQuery } from 'store/services/segmentsApi';
import { userDetailsState } from 'store/userDetailsSlice';

/**
 * Account settings and avatar component
 * @param {{fullSize:boolean, mobile?:boolean}} param0
 * @returns
 */
export default function UserAvatar({ fullSize, mobile }) {
  const { avatar_url, loggedInUser } = useSelector(userDetailsState);

  const { data } = useGetUserInfoQuery();

  const colorScheme = {
    desktop: 'bg-white bg-opacity-10 text-white',
    mobile: 'bg-segments-gray-F8 text-black',
  };

  return (
    <div className="flex flex-col items-center w-full h-full">
      {fullSize ? (
        <div
          className={`flex items-center justify-between w-full h-16 pl-5 shadow-md  rounded-segments-10px pr-7 ${
            mobile ? colorScheme.mobile : colorScheme.desktop
          }`}
        >
          <div className="flex items-center space-x-5">
            <Avatar avatar_url={avatar_url ?? ''} />
            <p className="truncate">{loggedInUser || data?.name}</p>
          </div>
        </div>
      ) : (
        <div className="mb-3">
          <Avatar avatar_url={avatar_url ?? ''} />
        </div>
      )}
    </div>
  );
}

/**
 * Avatar Image component
 * @param {{avatar_url:string}} param0
 * @returns
 */
function Avatar({ avatar_url = '' }) {
  return (
    <img
      alt="gravatar"
      className="w-10 h-10 border border-white rounded-full"
      src={avatar_url}
    />
  );
}
